export default __webpack_public_path__ + "a22d9fec2cc2c3aea061e5cc2c5948ff.png";